//==========================================================================
// top.js
//==========================================================================

function initOutlineSlider() {
  $('.js-outline-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    centerMode: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    variableWidth: true,
    speed: 750,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    swipe: true,
    touchMove: true,
    draggable: true,
  });
}

//------------------------------
$(function () {
  initOutlineSlider();
});

